import { Injectable } from "@angular/core";
import { QueryStringSerializationService } from "../../../shared-library/services/environment/query-string-serialization.service";
import {BaseSearchParametersModel} from "../models/base-search-parameters.model";

@Injectable({
    providedIn: "root"
})
export class SearchParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public createFromQueryString(queryString: string): BaseSearchParametersModel {
        const rawValues = this._serializationService.deserializeToType<BaseSearchParametersModel>(queryString);
        return this.createFromObject(rawValues);
    }

    public createFromObject(rawValues: {[key: string]: any}): BaseSearchParametersModel {
        const parsedValues = new BaseSearchParametersModel();

        parsedValues.searchTab = rawValues.searchTab || "directory";
        parsedValues.searchText = (rawValues.searchText as string || "").replace(/(\+)+/gi, " ").trim();
        parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
        parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 15;
        parsedValues.sortOption = rawValues.sortOption || (!!rawValues.searchText ? "Rank;asc" : "Name;asc");

        return parsedValues;
    }
}
